import React, { CSSProperties } from "react";
import "./Spinner.css";

export interface SpinnerProps {
  visible?: boolean;
  style?: CSSProperties;
}

export const Spinner: React.FC<SpinnerProps> = ({ visible = true, style }) => {
  if (!visible) {
    return null;
  }

  return <span className="spinner-bebop-many-modal-loading" role="status"></span>;
};
